import React from "react";

const AuthContext = React.createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null);
  const [verified, setVerified] = React.useState(null);

  const actions = {
    Logged(payload) {
      localStorage.setItem("userdata", JSON.stringify(payload));
      setUser(payload);
    },
    isLogged() {
      let user = JSON.parse(localStorage.getItem("userdata"));
      if (user) {
        setUser(user);
        return setVerified(true);
      }
      setUser(null);
      setVerified(true);
    },
    Logout() {
      localStorage.removeItem("userdata");
      console.log(localStorage);
      setUser(null);
    },
  };

  const value = {
    user,
    verified,
    Logged: actions.Logged,
    isLogged: actions.isLogged,
    Logout: actions.Logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => React.useContext(AuthContext);
